import React from 'react';
import {SortableHandle} from 'react-sortable-hoc';

import './drag-handle.scss';

export const DragHandle = () => {
  return <div aria-label='drag handle' className='drag-handle' role='button' tabIndex={0} />;
};

export const SortableDragHandle = SortableHandle(() => <DragHandle />);
